import { PROVIDER_TYPES } from '@/vars/general'

const CHANNEL_GROUPS = {
    [PROVIDER_TYPES.whatsappBasis]: 'whatsapp',
    [PROVIDER_TYPES.whatsappApi]: 'whatsapp',
    [PROVIDER_TYPES.whatsapp]: 'whatsapp',
    [PROVIDER_TYPES.whatsappDh]: 'whatsapp',
    [PROVIDER_TYPES.telegramApi]: 'telegram',
    [PROVIDER_TYPES.telegramDh]: 'telegram',
    [PROVIDER_TYPES.maxBasis]: 'max',
    [PROVIDER_TYPES.maxDh]: 'max',
    [PROVIDER_TYPES.maxBusiness]: 'maxBusiness',
    [PROVIDER_TYPES.smsGate]: 'sms',
}

/**
 * Открывает глобальный сайдбар создания канала (ConnectorSettingsSidebar).
 * @param {import('vue').default} vm
 * @param {object|null|undefined} item
 * @param {'new'|'transfer'} [initialTab='new']
 * @param {{ context?: string|null }} [options]
 * @returns {boolean}
 */
export function openChannelCreationSidebar(vm, item, initialTab = 'new', { context = null } = {}) {
    const store = vm.$store
    const lockCount = store.state.channelCreationLockCount || 0
    if (lockCount > 0) {
        store.dispatch('callNotify', 'Дождитесь завершения создания канала и установки приоритетов')
        return false
    }

    store.commit('setChannelCreationContext', context || null)
    store.commit('setChannelCreationMode', true)
    store.commit('setChannelCreationStage', 1)

    const wasOpen = !!store.state.isConnectorSettingsSidebar
    if (wasOpen) {
        store.commit('setIsConnectorSettingsSidebar', false)
        vm.$nextTick(() => {
            store.commit('setIsConnectorSettingsSidebar', true)
        })
    } else {
        store.commit('setIsConnectorSettingsSidebar', true)
    }

    const channelType = item?.channelType || item?.connectorType
    const groupId = item?.group || CHANNEL_GROUPS[channelType] || null
    const newUrl = new URL(window.location.href)
    newUrl.searchParams.set('connectTab', initialTab)

    if (groupId) {
        newUrl.searchParams.set('group', groupId)
    } else {
        newUrl.searchParams.delete('group')
    }

    if (item?._slotId !== undefined && item?._slotId !== null) {
        newUrl.searchParams.set('slotId', String(item._slotId))
    } else {
        newUrl.searchParams.delete('slotId')
    }

    window.history.replaceState({}, '', newUrl.toString())
    return true
}
